// React
import { useMemo } from 'react';

// Shared components
import { DataTableTabs } from '@components/DataTable/DataTableTabs';

// Hooks
import { useTranslation } from '@hooks/useTranslation';

// Types
import {
  RESALE_ITEM_STATUS_VALUES,
  type ResaleItemStatus,
  type ResaleItemTab,
  type ResaleItemsTabsProps,
} from '../types';

export function ResaleItemsTabs({
  currentStatus,
  onStatusChange,
  disabled = false,
  layoutId,
  className,
}: ResaleItemsTabsProps) {
  const { t } = useTranslation();

  const tabs = useMemo<ResaleItemTab[]>(
    () =>
      RESALE_ITEM_STATUS_VALUES.map((status) => ({
        key: status,
        label: t(`tabs.${status}`),
      })),
    [t],
  );

  return (
    <DataTableTabs<ResaleItemStatus>
      tabs={tabs}
      value={currentStatus}
      onValueChange={onStatusChange}
      disabled={disabled}
      layoutId={layoutId}
      className={className}
    />
  );
}
